export default "__VITE_ASSET__CvRNMsvx__"